<template>
    <!-- <v-data-table
        :headers="headers"
        :items="tableDatas"
        :search="search"
        :loading="loading"
        :items-per-page="8"
        :value="value"
        loading-text="Loading... Please wait"
        show-select
        item-key="aid"
        class="data-table elevation-0"
        @input="enterSelect($event)"
        @click:row="infoClick"
    > -->
    <v-data-table
        :headers="headers"
        :items="tableDatas"
        :search="search"
        :loading="loading"
        :items-per-page="rowsPerPage"
        :value="value"
        loading-text="Loading... Please wait"
        show-select
        item-key="aid"
        class="data-table elevation-0"
        @input="enterSelect($event)"
        @click:row="infoClick"
        hide-default-footer
    >


   
        <template v-slot:item.image="{ item }" fixed>
                <div class="image-container ma-1">
                    <v-img 
                    :src="getImage(item.image)"
                    style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;"
                    :contain="true"
                    >
                    <div class="overlay_wrap" v-if="codecCheck(item)==='encoded'" >
                    <v-tooltip bottom  color="#FFF3F3">
                        <template v-slot:activator="{ on, attrs }">
                            
                                <div class="overlay">
                                    <v-icon v-bind="attrs" v-on="on" color="error" style="background: #fff;border-radius: 50%;">mdi-alert-circle</v-icon>
                                </div>

                        </template>
                        <span style="color: #FF0505;">인코딩 후 영상 재생이 가능합니다.</span>
                    </v-tooltip>
                    </div>
                    <div class="overlay_wrap" v-else-if="codecCheck(item)==='extract'" >
                    <v-tooltip bottom  color="#FFF3F3">
                        <template v-slot:activator="{ on, attrs }">
                            
                                <div class="overlay">
                                    <v-icon v-bind="attrs" v-on="on" color="error" style="background: #fff;border-radius: 50%;">mdi-alert-circle</v-icon>
                                </div>

                        </template>
                        <span style="color: #FF0505;">메타데이터 추출 중입니다.</span>
                    </v-tooltip>
                    </div>
                    <div class="overlay_wrap" v-else-if="codecCheck(item)==='waiting'" >
                    <v-tooltip bottom  color="#FFF3F3">
                        <template v-slot:activator="{ on, attrs }">
                            
                                <div class="overlay">
                                    <v-icon v-bind="attrs" v-on="on" color="error" style="background: #fff;border-radius: 50%;">mdi-alert-circle</v-icon>
                                </div>

                        </template>
                        <span style="color: #FF0505;">인코딩 대기 중입니다.</span>
                    </v-tooltip>
                    </div>
                    <div class="overlay_wrap" v-else-if="codecCheck(item)==='abnormal'" >
                    <v-tooltip bottom  color="#FFF3F3">
                        <template v-slot:activator="{ on, attrs }">
                            
                                <div class="overlay">
                                    <v-icon v-bind="attrs" v-on="on" color="error" style="background: #fff;border-radius: 50%;">mdi-alert-circle</v-icon>
                                </div>

                        </template>
                        <span style="color: #FF0505;">비정상적인 파일입니다.</span>
                    </v-tooltip>
                    </div>
                    </v-img>
                </div>
            </template>
        
        <!-- <template v-slot:item.runtime="{ item }">
            <div v-for="(icon, index) in codecCheck(item.assetId)" :key="index" >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" v-if="icon" color="error">mdi-alert-circle</v-icon>{{ item.runtime }}
                    </template>
                    <span>인코딩 후 영상 재생이 가능합니다.</span>
                </v-tooltip>
            </div>
        </template> -->
        <template v-slot:item.status="{ item }">
            <!-- <Chips v-for="(chip, index) in chips(item.assetId)" :key="index" :chipText="chip.text" :ChipsColor="chip.color"/> -->
            <template v-for="(chip, index) in chips(item.assetId)">
                <template v-if="chip.text == 'processing ...' || chip.text.includes('processing ...')">
                    <v-progress-circular 
                        :key="'progress-' + index"
                        :rotate="-90"
                        :size="33"
                        :width="5"
                        :value="chip.percent"
                        class="mr-1"
                        >
                        <span style="font-size: 10px;">{{ chip.percent }}%</span>
                    </v-progress-circular>
                </template>
                <template v-else>
                    <Chips :key="'chips-' + index" :chipText="chip.text" :ChipsColor="chip.color" class="mr-1"/>
                </template>
            </template>
           <!-- <v-progress :key="index" :value="chip.id"></v-progress> -->
          
            <!-- <template v-if="item.status && isProgress(item.status)">
                    <template v-for="(key, index) in getData(item)">
                        <v-progress-circular 
                        :key="index"
                        :rotate="180"
                        :size="40"
                        :width="6"
                        :value="80"
                        >
                        <span style="font-size: 12px;">{{ key }}%</span>
                        </v-progress-circular>
                    </template>
            </template>
                <template v-if="item.status && isEncoded(item.status)">
                    <Chips v-for="(key, index) in getData(item)" :key="index" :chipText="key + 'p'" :ChipsColor="getColor(item.status)"/>
                </template> -->
                <!-- <template v-if="item.status && isProgress(item.status)">
                    <template v-for="(key, index) in getData(item)">
                        <v-progress-circular 
                        :key="index"
                        :rotate="180"
                        :size="40"
                        :width="6"
                        :value="key.percent"
                        >
                        <span style="font-size: 12px;">{{ key.percent }}%</span>
                        </v-progress-circular>
                    </template>
                </template>
                <template v-if="item.status && isEncoded(item.status)">
                    <Chips v-for="(key, index) in getData(item)" :key="index" :chipText="key + 'p'" :ChipsColor="getColor(item.status)"/>
                </template> -->
        </template>

        <template v-slot:item.groupData="{ item }">
            <!-- <div style="width: 150px;" class="mt-1">
                <template v-if="item.groupData.length">
                    <span v-for="(group, index) in item.groupData" :key="index" :style="{ backgroundColor: generateColor(group) }" class="asset_group">
                        {{ group }}
                    </span>
                </template>
            </div> -->
                <template v-for="(group, index) in item.groupData.slice(0, 3)">
                    <span :key="index" :style="{ backgroundColor: generateColor(group) }" class="asset_group">
                        {{ group }}
                    </span>
                </template>
                <span v-if="item.groupData.length > 3" class="asset_group_more">
                    외 {{ item.groupData.length - 3 }}개
                </span>
        </template>

        <template v-slot:item.social_upload="{ item, index }">
            <!-- <v-btn icon @click.stop="openDialog(item, index)" @input="resetStepper"> -->
            <v-btn icon @click.stop="openDialog(item, index)">
                <v-icon class="mdi mdi-cloud-upload-outline"/>
            </v-btn>
            <!-- <SocialUploadModal :value="modalOpen" @input="modalOpen = $event" /> -->
            <AppDialogLarge :value="modalOpen[index]" @input="modalOpen[index] = $event" max-width="100px" persistent>
                
                <template v-slot:title>
                    <span>{{ item.name }}</span>
                </template>

                <template v-slot:content>
                    
                    <v-stepper v-model="e1" elevation="0">
                        <div class="stepperheader">
                        <v-stepper-step
                            :complete="e1 > 1"
                            step="1"
                            class="pa-2"
                        >
                            내용 입력
                        </v-stepper-step>

                        <v-divider style="max-width:20%; margin-top: 36px;"></v-divider>

                        <v-stepper-step
                            :complete="e1 > 2"
                            step="2"
                            class="pa-2"
                        >
                            업로드 전 확인
                        </v-stepper-step>

                        <v-divider style="max-width:20%; margin-top: 36px;"></v-divider>

                        <v-stepper-step
                        step="3"
                        class="pa-2">
                            업로드 완료
                        </v-stepper-step>
                        </div>

                    <v-stepper-items>
                    <v-stepper-content class="pa-0 mb-0" step="1">
                        <div style="display: flex;justify-content: space-between;margin-bottom: 12px;">
                            <div style="width: 280px;">
                                <div class="upload-container">
                                    <v-img 
                                    :src="getImage(item.image)"
                                    style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;"
                                    :contain="true"
                                    >
                                    </v-img>
                                </div>
                            </div>
                            <div>
                                <v-card class="pa-3 mb-3" outlined @click="selYouTube" :class="{ 'selected': selectedCard === 'youtube' }">
                                    <v-row class="socialupload">
                                        <div class="type_check">
                                            <v-checkbox
                                            class="mt-2"
                                            v-model="isChecked"
                                            :disabled="selectedCard !== 'youtube'"
                                            />
                                        </div>
                                        <div class="mr-2">
                                            <v-img src="@/styles/youtube.png" width="40" class="mt-2"/>
                                        </div>
                                        <div>
                                            <h3>Youtube</h3>
                                            <span class="type_txt">섬네일, 설명, 공개/비공개, 카테고리 </span>
                                            <span v-if="!googleLogin" class="not_connected">NOTCONNECTED</span>
                                            <span v-else class="connected">CONNECTED</span>
                                        </div>
                                    </v-row>
                                </v-card>
                                <v-card class="pa-3" outlined disabled @click="selectedCard = 'facebook'" :class="{ 'selected': selectedCard === 'facebook' }">
                                    <v-row class="socialupload">
                                        <div class="type_check">
                                            <v-checkbox class="mt-2" />
                                        </div>
                                        <div class="mr-2">
                                            <v-img src="@/styles/facebook.png" width="40" class="mt-2 mr-1"/>
                                        </div>
                                        <div cols="9">
                                            <h3>FaceBook</h3>
                                            <span class="type_txt">해당 서비스는 준비 중 입니다. </span>
                                        </div>
                                    </v-row>
                                </v-card>
                            </div>
                        </div>

                        <div v-if="selectedCard === 'none'"  class="nonetype">
                            <v-card outlined height="220px" class="media_none mb-3">
                                <div>
                                    <img src="@/styles/socialimage.png" />
                                    <div class="txt">업로드할 소셜 미디어를 선택해주세요.</div>
                                </div>
                            </v-card>
                        </div>

                        <!--notconnected ui-->
                        <!-- <div class="nonetype">
                            <v-card outlined height="220px" class="notconnecttype mb-3">
                                <div class="text-center">
                                    <img src="@/styles/youtube.png" width="50"/>
                                </div>
                                <div class="text-center mt-2">
                                    <h3>Connect to Youtube</h3>
                                    <div class="txt mt-1">유튜브 소셜 미디어가 연동 되지 않았습니다.<br>연동 작업을 진행해주세요.</div>
                                </div>
                                <div class="text-center mt-3">
                                    <router-link to="/social-Connected">
                                        <TextButton buttonText="connect" isPrimary />
                                    </router-link>
                                </div>
                            </v-card>
                        </div> -->

                        <div v-else-if="selectedCard === 'youtube'" class="youtubetype">
                            <h4>Title</h4>
                            <AppTextField v-model="uploadTitle"/>

                            <h4>Description</h4>
                            <!-- <textarea name="" placeholder="설명입니다." outlined
                            class="textarea"></textarea> -->
                            <div style="height: 40px;" class="mb-4 mt-2">
                                <v-textarea name="" placeholder="설명입니다." dense outlined v-model="uploadDescript" color="black" height="20px"/>
                            </div>

                            <v-row class="mb-3">
                                <v-col class="mr-2">
                                    <h4>Privacy</h4>
                                    <!-- <AppSelect style="height: 40px;"></AppSelect> -->
                                    <SelectBox :items="standardVal.privacyData" :datas="uploadStatus" style="height: 40px;" @item-selected="onPrivacySelected"></SelectBox>
                                </v-col>
                                <v-col>
                                    <h4>Category</h4>
                                    <!-- <AppSelect style="height: 40px;"></AppSelect> -->
                                    <SelectBox :items="standardVal.youtubeCat" :datas="uploadCate" style="height: 40px;" @item-selected="onCateSelected"></SelectBox>
                                </v-col>
                            </v-row>
                        </div>

                        <div>
                            <TextButtonBlock buttonText="취소" :width="'49.5%'" @click="closeDialog(index)"/>
                            <TextButtonBlock buttonText="다음" @click="e1 = 2" :width="'49.2%'" class="ml-2" isPrimary />
                        </div>

                    </v-stepper-content>

                    <v-stepper-content class="pa-0 mb-0" step="2">

                        <v-card class="pa-0" height="428px">
                            <v-card outlined height="380px" class="media_none mb-3 pt-3">
                                <div style="align-items: center;justify-content: center;display: grid;">
                                    <!-- <v-img :src="getImage(item.image)" style="border-radius: 8px;width: 350px;" class="mt-3 mb-3"/> -->

                                    <div class="upload-container2">
                                        <v-img 
                                            :src="getImage(item.image)"
                                            style="position: absolute;height: 197px; top: 0; object-fit: contain; object-position: top center;padding: 0;"
                                            :contain="true" />
                                    </div>

                                    <!--asset title-->
                                    <div class="text-center mt-2">
                                        <h3 class="upload_title">{{ uploadTitle }}</h3>
                                    </div>

                                    <v-row class="mt-3 mb-2">
                                        <!--Youtube-->
                                        <v-col>
                                            <v-card class="text-center pa-3" elevation="0" color="#f9f9f9">
                                                <img src="@/styles/youtube.png" height="20"/>
                                                <h3>Youtube</h3>
                                            </v-card>
                                        </v-col>
                                        <!--Facebook-->
                                        <!-- <v-col>
                                            <v-card class="text-center pa-3 ml-2" elevation="0" color="#f9f9f9">
                                                <img src="@/styles/facebook.png" height="20"/>
                                                <h3>FaceBook</h3>
                                            </v-card>
                                        </v-col> -->
                                    </v-row>

                                    <!--업로드 전 마지막 확인-->
                                    <div class="text-center">
                                        <span>영상을 업로드 하시겠습니까?</span>
                                    </div>

                                </div>
                            </v-card>
                            <TextButtonBlock buttonText="이전" :width="'49.5%'" @click="e1 = 1"/>
                            <!-- <TextButtonBlock buttonText="업로드" @click="e1 = 3" :width="'49.2%'" class="ml-2" isPrimary /> -->
                            <TextButtonBlock :disabled="btnStatus" buttonText="업로드" @click="socialUpload" :width="'49.2%'" class="ml-2" isPrimary />
                            <v-overlay v-model="overlayVal" class="align-center justify-center">
                                <v-progress-circular color="primary" size="64" indeterminate></v-progress-circular>
                            </v-overlay>
                        </v-card>

                    </v-stepper-content>

                    <v-stepper-content class="pa-0 mb-0" step="3">
                        <v-card outlined height="380px" class="media_none mb-3">
                            <div  style="display: grid;align-content: center;justify-content: center;height: 380px;">
                                <div class="text-center">
                                    <img src="@/styles/socialimage_color.png"/>
                                </div>
                                <div class="text-center">
                                    <div class="text-center mt-4 mb-2">
                                        <h3 class="upload_title">{{ uploadTitle }}</h3>
                                    </div>
                                    <span>업로드가 완료되었습니다.</span>
                                </div>
                            </div>
                            
                        </v-card>

                        <div class="text-center">
                            <TextButtonBlock buttonText="닫기" @click="endUpload()"/>
                        </div>

                    </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>

                    

                </template>
                <!-- <template v-slot:actions>
                    <TextButtonBlock buttonText="취소" @click="closeModifyGroupName" />
                    <TextButtonBlock buttonText="업로드" @click="handleUpdateGroupName" :width="'49%'" isPrimary />
                </template> -->
            </AppDialogLarge>
        </template>



        
      
    </v-data-table>
</template>

<script>
import Chips from '@/components/ui/chips/Chips.vue';
import AppDialogLarge from '@/components/app/AppDialogLarge.vue';
import { mapState, mapGetters } from 'vuex';
import AssetApi from '@/api/asset/AssetApi';
import TemplateFormVue from '../template/TemplateForm.vue';
import SocialUploadModal from '@/components/socialupload/SocialUploadModal.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import AppTextField from '@/components/app/AppTextfield';
import AppSelect from '@/components/app/AppSelect.vue';
import SelectBox from '@/components/asset/SelectBox.vue';
import SocialApi from '@/api/social/SocialApi';

export default {
    components: {
        Chips,
        SocialUploadModal,
        AppDialogLarge,
        TextButton,
        TextButtonBlock,
        AppTextField,
        AppSelect,
        SelectBox,
    },
    props: {
        headers: {
        type: Array,
        required: true
        },
        items: {
        type: Array,
        required: true
        },
        loading: {
        type: Boolean,
        required: true
        },
        search: {
        type: String,
        required: true
        },
        rowsPerPage: {
        type: Number,
        required: true
        },
        enterSelect: {
        type: Function,
        required: true
        },
        value: {
        type: Array,
        required: true
        },
        rowClick: {
        type: Function,
        required: true
        },
    },
    data() {
        return {
            result: {},
            flag: null,
            progress: [],
            modalOpen: [],
            e1: 1,
            selectedCard: 'none',
            isChecked: false,
            uploadTitle: null,
            uploadStatus: 'private',
            uploadCate: '인물/블로그',
            uploadDescript: null,
            filename: null,
            btnStatus: false,
            overlayVal: false,
        }
    },
    mounted() {
        // this.flag = false;
        // if(this.items && this.dataLoad){
        //     this.flag = true;
        // }
        this.modalOpen = this.items.map(() => false);
    },
    // watch: {
    //     tableDatas: {
    //         handler() {
    //             this.updateProgressBar();
    //         },
    //         immediate: TemplateFormVue
    //     }
    // },
    computed: {
        ...mapState('asset', ['dataLoad']),
        ...mapGetters('objectData', ['getStandard']),
        chips() {
            return (id) => {
                if(this.dataLoad && this.tableDatas){
                    return this.getChipData(id);
                    // if(!this.result[id]){
                    //     this.getChipData(id);
                    // }
                    // return this.result[id];
                }
                else {
                    return null;
                }
                // if(!this.result[id]){
                //     this.getChipData(id);
                // }
                // return this.result[id];
               
            }
        },
        tableDatas(){
           if(this.dataLoad && this.items){
                return this.items;
           }
           return this.items;
        },
        standardVal(){
            return {
                privacyData: this.getStandard('privacyData'),
                youtubeCat: this.getStandard('youtubeCat'),
            }
        },
        googleLogin(){
            const googleToken = sessionStorage.getItem("google_access_token");
            console.log("googleToken => ", googleToken)
            if(googleToken){
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        // sizeCheck(item){
        //     if((item.size_bytes) > 256 * 1024 * 1024 * 1024){
        //         return false;
        //     } else {
        //         return true;
        //     }
        // },
        // codecCheck(item){
        //     // if(item.upload_v_codec !== 'h264' && (item.status === 'uploaded' || item.status === 'processing')){
        //     //     return true; 
        //     // } else if((item.status === 'h264' || item.status !== 'h264') && item.status.includes('encoded')){
        //     //     return false;
        //     // }
        //     if(item.upload_v_codec !== 'h264' && (item.status === 'uploaded' || item.status === 'processing')){
        //         return true; 
        //     } else if((item.upload_v_codec === 'h264' || item.upload_v_codec !== 'h264') && item.status.includes('encoded')){
        //         return false;
        //     } else if(item.upload_v_codec === 'h264' && item.status === 'uploaded'){
        //         return false; 
        //     }
        // if(this.dataLoad && this.tableDatas){
            //     // console.log(this.tableDatas.map((e) => e))
            //     const list = this.tableDatas.filter(e => e.assetId === id);
            //     const data = list.map(e => e.upload_v_codec !== 'h264');
            //     return data;
            // }
        codecCheck(item){
            if(item.upload_v_codec != 'h264' && (item.status == 'uploaded' || item.status == 'processing')){
                return 'encoded';
            } else if((item.status == 'h264' || item.status != 'h264') && item.status.includes('encoded')){
                return 'upload';
            }  else if(item.status == 'extract' || item.status.includes('extract')){
                return 'extract';
            } else if(item.status == 'abnormal' || item.status.includes('abnormal')){
                return 'abnormal';
            } else if(item.status == 'waiting' || item.status.includes('waiting')){
                return 'waiting';
            } 
        },
        getImage(src){
            if (src && src.trim() !== "") {
                return src;
            } else {
                return "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png";
            }
        },
        infoClick(val){
            // this.$emit('rowClick');
            this.rowClick(val);
        },
        updateType(val) {
            return val.toString().split(" ")[0];
        },
        // enterSelect(value) {
            
        //     console.log("dd => ", value)
        //     this.$emit('input', value); 
        // },
        // flattenAndCompare(arr1, arr2) {
        //     const flattenedArr2 = (arr2.map(e=>e.encoding_type)).flat();  
        //     console.log("flat => ", flattenedArr2)
        //     return arr1.filter(item1 => !flattenedArr2.includes(item1)); 
        // },
        saveInfo(id, result){
            // this.result[id] = result;
            this.$set(this.result, id, result);

            //console.log("saveInfo 확인 => ", this.result)
        },
        getChipData(id) {

            const result = [];
            // const datas = this.tableDatas.map(e => e.sortOut);
            // const data = datas.map(e => e).reduce((acc, curr) => acc.concat(curr), []);  // datas.flatMap(e => e);
            // const filter = data.filter(e => e.origin_asset_id === id);
            // const datas = this.tableDatas.map(e => e.encodingInfo);
            // const data = datas.map(e => e).reduce((acc, curr) => acc.concat(curr), []);  // datas.flatMap(e => e);
            // const filter = data.filter(e => e.origin_asset_id === id);
            // // const filteredData = filter.map(e => e);
            // // console.log("필터링 데이터 2=> ", filter)

            // const res = filter.map(e => {
            //     // console.log(e.status)
            //     const text = e.status.match(/^processing\s/) ? 'processing' : this.updateType(e.type);
            //     const color = e.status === 'encoded' ? 'black' : '!black';
            //     const percent = e.status.match(/^processing\s/) ? (e.percent ? e.percent : null) : null;

            //     return {
            //         text: text,
            //         color: color,
            //         percent: percent
            //     };
            // });

            // const data = this.tableDatas.map(e => e.encodingInfo).reduce((acc, curr) => ascc.concat(curr), []);
            const data = this.tableDatas.map(e => e.encodingInfo).flat();
            const filtered = data.filter(e => e.origin_asset_id === id);
            // console.log(filtered)

            const typeDatas = {};
            filtered.forEach(e => {
                const type = e.type;
                const text = e.status === 'processing ...' ? 'processing ...' : this.updateType(e.type);
                const status = e.status;
                const percent = status === 'processing ...' ? (e.percent || 0) : null;

                typeDatas[type] = {
                    text: text,
                    color: status === 'encoded' ? 'black' : '!black',
                    percent: percent
                };
            });

            for (const type in typeDatas) {
                result.push(typeDatas[type]);
            }

            // console.log(result)



        //     const res = filtered.map(e => {
        //         const text = e.status.startsWith('processing') ? 'processing' : this.updateType(e.type);
        //         const color = e.status === 'encoded' ? 'black' : '!black';
        //         const percent = e.status.startsWith('processing') ? (e.percent || 0) : null;
        //         // const percent = e.status.match(/^processing\s/) ? this.progress : null;

        //         return {
        //             text: text,
        //             color: color,
        //             percent: percent
        //         };
        //     });

        //     result.push(...res);

        //   //   console.log("res =====> ", result)


            return result;

            // const datas = this.tableDatas.map(e => e.sortOut);
            // const data = datas.flatMap(e => e);
            // const filter = data.filter(e => e.origin_asset_id === id);
            // console.log("필터링 데이터 1=> ", filter)

           
            // filter.forEach(e => {
            //     let text = filter.map(e => e.type) === 'processing' ? 'processing' : this.updateType(filter.map(e => e.type));
            //     let color = filter.map(e => e.status) === 'encoded' ? 'black' : '!black'; 
                
            //     // const result = {
            //     //     text: text,
            //     //     color: color
            //     // };

            //     text.split(',').forEach(e => {
            //         this.saveInfo(id, { text: e.trim(), color });
            //     });

                // this.$set(this.result, id, {
                //     text: text,
                //     color: color,
                //     id: id 
                // });
            // });
            
            // const all = datas.flatMap(e => e.map(obj => obj.type));
            // if (filter.length > 0) {
                // filter.forEach(e => {
                //     texts.push(e.type === 'processing' ? 'processing' : this.updateType(e.type));
                //     colors.push(e.status === 'encoded' ? 'black' : e.status);
                // });

           


           
                // let text = filter.map(e => e.type) === 'processing' ? 'processing' : this.updateType(filter.map(e => e.type));
                // let color = filter.map(e => e.status) === 'encoded' ? 'black' : '!black'; 
                // let size = filter.map(e => e.size);
                // let resolution = filter.map(e => e.resolution);

                // this.saveInfo(id, {text, color, size, resolution});

                // this.$set(this.result, id, {
                //     text: text,
                //     color: color,
                //     size: sizes,
                //     resolution: resolutions,
                //     id: id 
                // });
            // }

            // this.result = res;
            // console.log("getChipData => ", this.results)
            // return this.result;
            

                // const datas = this.tableDatas.map(e => e.sortOut);
                // // const all = datas.flatMap(e => e.map(obj => obj.type));
                // // console.log("확인check => ", this.tableDatas)
                // const filter = datas.filter(e => e[0].origin_asset_id === id);
                // // console.log("확인checktempDatatempData => ", filter)
                // let text = filter.map(e => e.type) === 'processing' ? 'processing' : this.updateType(filter.map(e => e.type));
                // let color = filter.map(e => e.status) === 'encoded'? 'black' : filter.map(e => e.status)
                // res.push({
                //     text: text,
                //     color: color,
                //     size: filter ? filter.map(e => e.size) : null,
                //     resolution: filter ? filter.map(e => e.resolution) : null,
                //     id: filter ? filter.map(e => e.id) : null
                // });
                // return res;
               
                // const result = filter.map(e => {
                //     const types = e.map(e => e.type);
                //     const status = e.map(e => e.status);
                //     // // const text = types === 'processing' ? 'processing' : this.updateType(types);
                //     // const text = types.includes('processing') ? 'processing' : this.updateType(types);
                //     // // const color = status === 'encoded'? 'black' : status
                //     // const color = status.includes('encoded') ? 'black' : this.updateType(types);

                //     return { text, color };
                // });
                // console.log("결과확인 -> ", result)
                // return result;
        

            // const encodingInfo = this.items.flatMap(e => e.encodingInfo);
            // const filter = encodingInfo.filter(e => e.origin_asset_id === id);
            // this.$set(this.result, id, filter.map(e => {
            //     let text;
            //     if ('ischeck' in e) {
            //         text = e.type;
            //     } else {
            //         text = (e.status === 'processing') ? 'processing' : e.type;
            //     }
            //     const color = ('ischeck' in e) ? '!black' : ((e.status === 'encoded' || e.status === 'processing') ? 'black' : '!black');
            //     return { text, color };
            // }));

                // console.log("result => ", this.result);
        },
            

            // // 필터링된 데이터
            // const filter = encodingInfo.filter(e => e.origin_asset_id === id);
            // // console.log("filter => ", filter)

            // // 해상도, 상태 추출 (From filtered data)
            // this.result = filter.map(e => {
            //     let text;
            //     let status;
            //     if ('ischeck' in e) {
            //         text = e.type;
            //     } else {ㄹ
            //         text = (e.status === 'processing') ? 'processing' : e.type;
            //     }

            //     const color = ('ischeck' in e) ? '!black' : ((e.status === 'encoded' || e.status === 'processing') ? 'black' : '!black');

            //     return { text, color };
            // });
            generateColor1(group) {
            const hashCode = s => {
                let h = 0;
                for (let i = 0; i < s.length; i++) {
                    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
                }
                return h;
            };
            const color = "#" + ((hashCode(group) & 0xFFFFFF) << 0).toString(16);
            return color;
        },

        generateColor(group) {
            const hashCode = s => {
                let h = 0;
                for (let i = 0; i < s.length; i++) {
                    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
                }
                return h;
            };

            let hash = hashCode(group) + group.length * 123456 + group.charCodeAt(0) * 98765;
            let color = ((hash & 0xFFFFFF) << 0).toString(16);

            while (color.length < 6) {
                color = "0" + color;
            }

            return `#${color}`;
        },

        generateColor2(group) {
            const hashCode = s => {
                let h = 0;
                for (let i = 0; i < s.length; i++) {
                    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
                }
                return h;
            };

            let hash = hashCode(group) + group.length * 123456;
            let color = ((hash & 0xFFFFFF) << 0).toString(16);

            while (color.length < 6) {
                color = "0" + color;
            }

            return `#${color}`;
        },
        async socialUpload(){

            this.btnStatus = true;
            this.overlayVal = true;
            // console.log(item)
            // console.log("제목 : ", this.uploadTitle);
            // console.log("태그 : ", this.uploadDescript);
            // console.log("privacy : ", this.uploadStatus);
            // console.log("category : ", this.uploadCate);
            // console.log("상태 : ", item.status);    // "encoded" & "uploaded"
            // console.log("filename : ", this.filename);
            // console.log("frame : ", item.upload_frames);

            const token = sessionStorage.getItem("google_access_token");
            const params = {
                token: token,
                // status: item.status,   
                title: this.uploadTitle,
                category: this.uploadCate,
                privacy: this.uploadStatus,
                tag: this.uploadDescript,
                filename: this.filename,
                // frame: item.upload_frames,
                // bitrate: item.upload_bitrate,
                // type: item.upload_resolution,
                // direction: item.upload_direction,
            }

            const response = await SocialApi.uploadYouTube(params);
            console.log("유튜브 업로드 res => ", response);
            if(response.status === 1){
                setTimeout(() => {
                    this.overlayVal = false;
                    this.btnStatus = false;
                }, 3000)
                this.e1 = 3;
            } 
        },
        openDialog(item, index){
            this.clear();
            this.uploadTitle = item.name;
            this.uploadDescript = item.tagData;
            this.filename = item.filename;
            this.modalOpen[index] = true;
        },
        closeDialog(index){
            this.clear();
            this.modalOpen[index] = false;
        },
        endUpload(){
            // this.clear();
            // this.modalOpen[index] = false;
            this.modalOpen = this.modalOpen.map(() => false);
        },
        clear(){
            this.selectedCard = 'none';
            this.isChecked = false;
            this.uploadTitle = null;
            this.uploadDescript = null;
            this.filename = null;
            this.uploadStatus = 'private';
            this.uploadCate = '인물/블로그';
            this.e1 = 1;
        },
        onPrivacySelected(newVal){
            this.uploadStatus = newVal; 
        },
        onCateSelected(newVal){
            this.uploadCate = newVal; 
        },
        async selYouTube(){
            if(this.googleLogin){
                this.selectedCard = 'youtube';
                this.isChecked = true;
            } else {
                const response = await SocialApi.googleLogin();
            }
        },
        // resetStepper() {
        //     if (this.modalOpen) {
        //         this.e1 = 1;
        //     }s
        // },

    },
}
</script>

<style scoped>
.image-container{
    position: relative; 
    background-color: black; 
    width: 107px;
    height: 60px;
    display: flex; 
    justify-content: center; 
    align-items: center; 
    overflow: hidden;
    border-radius: 6px;
}

.upload-container{
    position: relative; 
    background-color: black; 
    width: 100%;
    height: 100%;
    display: flex; 
    justify-content: center; 
    align-items: center; 
    overflow: hidden;
    border-radius: 6px;
}

.upload-container2{
    background-color: black; 
    width: 100%;
    height: 197px;
    overflow: hidden;
    border-radius: 6px;
    display: flex; 
    justify-content: center; 
    align-items: center;
    position: relative;
}

.asset_group {
    color: #fff;
    opacity: 0.8;
    padding: 4px 8px;
    border-radius: 4px;
    margin-right: 4px;
    font-size: 11px;
    width: 70px;
    display:inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
}
.asset_group_more{
    color: #aaa;
    font-size: 12px;
    height: 20px;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(2) {
    padding: 0px;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(3) {
    width: 34%;
}
/* .data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(1) {
    width: 10px;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(2) {
    width: 1%;
    padding: 0px;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(3) {
    width: 32%;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(4) {
    width: 12%;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(5) {
    width: 2%;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(6) {
    width: 10%;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(7) {
    width: 10%;
} */

.overlay_wrap{
    width: 100%;
    height: 100%;
    background: rgba(255, 74, 74, 0.4);
}
.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
 
 border-radius: 50%;
  transform: translate(-50%, -50%);
}

.overlay v-icon {
  font-size: 48px;
  color: white;
  cursor: pointer;
}

.socialupload .type_txt{
    font-size: 12px;
    color: #888;
}
.socialupload .type_check{
    height: 46px;
    justify-content: center;
}
.nonetype .media_none{
    display: flex;
    justify-content: center;
    align-items: center;
}
.nonetype .media_none img{
    width: 160px;
    justify-content: center;
    align-items: center;
    display: flex;
}.nonetype .media_none .txt{
    color: #888;
}
.stepperheader{
    height: 72px;
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.media_none .upload_title{
    width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.not_connected {
    font-size: 10px;
    color: #F46545;
    background: #F7E3E1;
    padding: 4px 6px 4px 6px;
    border-radius: 4px;
    margin-left: 4px;
}
.connected{
    font-size: 10px;
    color: #49B040;
    background: #E6F7E1;
    padding: 4px 6px 4px 6px;
    border-radius: 4px;
    margin-left: 20px;
}

.notconnecttype{
    display: grid;
    align-content: center;
    justify-content: center;
    height: 200px;
}
.notconnecttype .txt{
    color: #888;
}
</style>
